export enum PaymentActionTypes {
    API_RESPONSE_SUCCESS = '@@payments/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@payments/API_RESPONSE_ERROR',

    REQUEST_PAYMENT = '@@payments/REQUEST_PAYMENT',
    GET_REDIRECT_PARAMS = '@@payments/GET_REDIRECT_PARAMS',
    GET_INSITE_PARAMS = '@@payments/GET_INSITE_PARAMS',
}
